import AvatarCard from "../avatar-card";

interface SpotlightPreviewProps {
    recognitionFor?: string[];
    description?: any;
    nomineeUser?: any;
    file?: any;
    projects?: string[];
    nominationType?: string;
}

export function SpotlightPreview({ recognitionFor, description, nomineeUser, file, projects, nominationType }: SpotlightPreviewProps) {
    return (
        <div>
            <div className="border border-feildBorder rounded-cardRadius mb-1 px-5 py-3.5 bg-white !w-[100%] max-w-[85rem]">

                <div className=" spotlight_avatar_wrap">
                    <AvatarCard
                        isViewMore={false}
                        imageUrl={file?.name ? URL.createObjectURL(file) : nomineeUser?.personal_image ? nomineeUser?.personal_image : nomineeUser?.logo_url}
                        title={nomineeUser?.name}
                        subTitle={nomineeUser?.job_title}
                        size="md"
                        projects={projects}
                        recognitionFor={recognitionFor}
                        avatarClassName="flex-start"
                        titleClassName="!text-xl"
                        className="spotlight_avatar [&_>.avatar-content]:!w-full [&_>.avatar-content>.avatar-heading]:!text-2xl space-x-3 w-full !items-start"
                    />
                </div>
                <div className="my-3">
                    <p className="text-[14.5px] !font-aeonikMed break-words"
                        dangerouslySetInnerHTML={{ __html: description }}
                    ></p>
                </div>
            </div>
        </div>
    );
}
export default SpotlightPreview;